import React from 'react';

import AppBarContext from './AppBarContext';
import ThemeSwitchContext from 'components/Theme/ThemeSwitchContext';

export default function useAppBar(title, buttons, disabled)
{
  const setAppBar = React.useContext(AppBarContext);
  const setTheme =  React.useContext(ThemeSwitchContext);
  React.useEffect(() =>
  {
    setTheme(disabled);
    return setAppBar({title, buttons, disabled});
  }, [setAppBar, title, buttons, disabled]);
}